import { mutatorAction } from 'satcheljs';
import type { MailboxFolderTreeData } from '../store/schema/FolderStore';
import getStore from '../store/store';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export const setMailboxFolderTreeDataMutator: (
    mailboxInfo: MailboxInfo,
    mailboxFolderTreeData: MailboxFolderTreeData
) => void = mutatorAction(
    'setMailboxFolderTreeData',
    (mailboxInfo: MailboxInfo, mailboxFolderTreeData: MailboxFolderTreeData): void => {
        getStore().mailboxFolderTreeData.set(
            getAccountKeyForMailboxInfo(mailboxInfo),
            mailboxFolderTreeData
        );
    }
);
